import React from "react";
import {
  IconButton,
  TextField as MuiTextField,
  TextFieldProps as MuiTextFieldProps
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

export type TextFieldProps = MuiTextFieldProps & {
  maxLength?: number;
  maxNumber?: number;
  minNumber?: number;
  clearable?: boolean;
  onClear?: () => void;
};

export const TextField = ({
  variant = "outlined",
  maxLength,
  maxNumber,
  minNumber,
  clearable = false,
  onClear = () => {},
  ...muiTextFieldProps
}: TextFieldProps): JSX.Element => {
  return (
    <MuiTextField
      variant={variant}
      inputProps={{
        maxLength: maxLength,
        min: minNumber,
        max: maxNumber,
        ...muiTextFieldProps.inputProps
      }}
      InputProps={{
        endAdornment: clearable ? (
          <IconButton
            disabled={muiTextFieldProps.disabled}
            aria-label="input clear button"
            onClick={onClear}
            edge="end"
            size="large"
          >
            <CloseIcon />
          </IconButton>
        ) : null,
        ...muiTextFieldProps.InputProps
      }}
      {...muiTextFieldProps}
    />
  );
};
